import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { EventVenueState } from './EventVenueDialog.types';

const page = 'accommodations.venue';
const category = 'website';
const pagePrefix = 'admin';
const action = 'TravelButtonInteracted';

const actionProps = {
  page,
  action,
  category,
  pagePrefix,
};

const telemetryObject = createTelemetryObject({
  pages: {
    eventVenueDialog: (state: EventVenueState) => ({
      category,
      pagePrefix,
      page: 'eventVenueDialog',
      extraPageInfo: {
        state,
      },
    }),
  },
  actions: {
    closeEventVenueDialog: (state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'closeEventVenueDialog',
      extraInfo: {
        state,
        eventHandle,
      },
    }),
    createSaveEventVenue: (location: { name?: string; latitude: number; longitude: number }, eventHandle?: string) => ({
      ...actionProps,
      label: 'createSaveEventVenue',
      extraInfo: {
        location,
        eventHandle,
      },
    }),
    updateEventVenue: (location: { name?: string; latitude: number; longitude: number }, eventHandle?: string) => ({
      ...actionProps,
      label: 'updateEventVenue',
      extraInfo: {
        location,
        eventHandle,
      },
    }),
    eventVenueDialogStateChanged: (state: EventVenueState, eventHandle?: string) => ({
      ...actionProps,
      label: 'eventVenueDialogStateChanged',
      extraInfo: {
        state,
        eventHandle,
      },
    }),
    resetHasSeenAccommodationsTour: () => ({
      ...actionProps,
      label: 'resetHasSeenAccommodationsTour',
    }),
  },
});

export const { useTelemetry: useEventVenueDialogTelemetry } = createTelemetry(telemetryObject);
